<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <div class="layout_row">
        <div class="layout_colum">
          <div class="ctn_bread">
            <Welcome v-bind="getUser"></Welcome>
          </div>
        </div>
        <div class="layout_colum">
          <Snackbar
            v-bind:visible="getAlert.snackbar"
            v-bind:text="getAlert.text"
          ></Snackbar>
          <div class="ctn_indicator">
            <Indicator
              v-bind:active="getListDeviceSucess.length"
              v-bind:activeText="'Exitoso'"
              v-bind:inactive="deviceInactive"
              v-bind:inactiveText="'Fallido'"
            ></Indicator>
          </div>
        </div>
      </div>
      <TableComp></TableComp>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Nav from '@/components/Nav.vue'
import TableComp from '@/components/device/TableReview.vue'
import Welcome from '@/components/Welcome.vue'
import Indicator from '@/components/Indicator.vue'
import Snackbar from '@/components/Snackbar.vue'
export default {
  name: 'DeviceTakeResult',
  components: {
    Nav,
    Welcome,
    Indicator,
    TableComp,
    Snackbar,
  },
  async created() {},
  methods: {
    ...mapActions(['listDevice']),
  },
  computed: {
    ...mapGetters([
      'getListDeviceSucess',
      'isLogin',
      'getUser',
      'getAlert',
      'getRol',
      'isMaster',
    ]),
    // deviceActive() {
    //   let active = this.getListDeviceSucess
    //     .map((item) => {
    //       if (item.sucess == true) {
    //         return item;
    //       }
    //     })
    //     .filter((item) => {
    //       return item;
    //     });
    //   return active.length;
    // },
    deviceInactive() {
      let active = this.getListDeviceSucess
        .map((item) => {
          if (item.sucess == false) {
            return item
          }
        })
        .filter((item) => {
          return item
        })
      return active.length
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base.scss';
.ctn_bread {
  display: flex;
  flex-direction: column;
  a.bread {
    padding: 5px;
    font-size: 0.9rem;
    color: $color-link;
  }
}
</style>
